import '../../css/UniverseLoading.css'

const UniverseLoading = () => {

    return (<><div className="universe-loading">

    <div id="stars"></div>
    <div id="container">
        <div id="earth"></div>
        <div id="rocket"></div>
    </div>
    </div></>)
}

export default UniverseLoading;